import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {map, Observable, take} from 'rxjs';
import {ServiceProviderHub, SingleResponse} from '@generated-backend-types';
import AppVersion = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.AppVersion

@Injectable({providedIn: 'root'})
export class AppVersionService extends ApiService {
  private readonly endpoint = '/version';

  public getVersion(): Observable<string> {
    return this.http.get<SingleResponse<AppVersion>>(this.endpoint)
      .pipe(take(1), map(value => value.data.version));
  }
}
